import React from 'react'
import { LinkLayout } from '../../../../../Shared/Frontend/utils/links'
import { pushDatalayer } from '../../../seo/datalayer'
import { PageHeader } from '../../cmsPage.state'
import { SharedBlockLayout } from '../../modernBlocks/blocks/shared/sharedBlock.layout'
import { convertTitleForBackground, unEntity } from '../../utils/html'

export const DonationHeaderLayout = (props: { header: PageHeader, form?: JSX.Element, step?: number }) => {
  const { image, linkPrimary, linkSecondary, pageIntro, pageTitle, publishDate } = props.header
  const stepClass = props.step != undefined ? ` step-${props.step < 2 ? 'initial' : 'x'}` : ''

  return (
    <header className={`pageheader donation-header ph--${image ? 'image' : 'text'} ls-container--l ls-gutter${stepClass}`}>
      <div className='ph__inner'>
        <div className='ph__content'>
          <div className='ph__content-inner'>
            {publishDate && (
              <time dateTime={publishDate.toISOString()} className='ph__meta text--s'>{publishDate.toLocaleString("nl-NL", {day: 'numeric', month: 'long', year: 'numeric'})}</time>
            )}

            {pageTitle && (
              <h1
                className='ph__title title--l title--bg title--left'
                dangerouslySetInnerHTML={{ __html: unEntity(convertTitleForBackground(pageTitle)) }}
              />
            )}

            {pageIntro ? (
              typeof pageIntro == 'string' ? (
                <p className='ph__intro text--l' dangerouslySetInnerHTML={{ __html: pageIntro }} />
              ) : (
                <p className='ph__intro text--l'>{pageIntro}</p>
              )
            ) : (
              <></>
            )}

            {(linkPrimary || linkSecondary) ? (
              <div className='ph__actions ls-clickables'>
                {linkPrimary && (
                  <div className="ph__action ls-clickable">
                    <LinkLayout
                      link={linkPrimary}
                      className='ph__button button button--primary button--on-darkred'
                      onClick={() => {
                        pushDatalayer({
                          event: 'event.gtm',
                          category: 'pageheader-cta',
                          action: 'primary-' + linkPrimary.title,
                          label: window.location.href
                        })
                      }}
                    >
                      <span className='button__label'>{linkPrimary.title}</span>
                    </LinkLayout>
                  </div>
                )}
                {linkSecondary && (
                  <div className="ph__action ls-clickable">
                    <LinkLayout
                      link={linkSecondary}
                      className='ph__link button button--secondary button--on-darkred'
                      onClick={() => {
                        pushDatalayer({
                          event: 'event.gtm',
                          category: 'pageheader-cta',
                          action: 'secondary-' + linkSecondary.title,
                          label: window.location.href
                        })
                      }}
                    >
                      <span className="button__label">{linkSecondary.title}</span>
                    </LinkLayout>
                  </div>
                )}
              </div>
            ) : (
              <></>
            )}
          </div>
        </div>
        {props.form}
      </div>
      {image && <div className="dh__visual">
        <div className='dh__visual-inner'>
          <SharedBlockLayout.ModernImageSrcSet
            image={image}
            lazyload={false}
            priority='high'
            classNames="ph__image"
            imageProportions={{
              width: '1280',
              height: '640',
              sizes: '(min-width: 1360px) 1312px, 100vw'
            }}
          />
        </div>
        <svg className="dh__mask-mobile" width="402" height="39" viewBox="0 0 402 39" fill="none" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M0 38.8088H402V9.6139C354.652 2.79447 306.732 -0.423264 258.65 0.0445583C171.333 -0.0716241 84.4474 12.2843 0.623326 36.7387L0 38.8088Z" fill="#6E273D"/></svg>
        <svg className="dh__mask" width="1312" height="207" viewBox="0 0 1312 207" fill="none" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M0 207H1312V111.5C1157.47 89.2095 999.075 78.6156 842.15 80.1448C557.176 79.765 273.609 120.153 0.0343366 200.087L0 207Z" fill="#6E273D"/></svg>
      </div>}
    </header>
  )
}
